import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';

import {
  DialogCloseReason,
  SuiDialogBase,
  SuiDialogSimpleComponent,
  SuiDialogHeaderSlot,
  SuiDialogContentSlot,
  SuiDialogFooterSlot,
} from '@sui/dialog';

import { DuplicateObjectErrorItem } from 'src/app/core/models/core.models';
import { SuiButtonComponent } from '@sui/button';
import { BusinessConstraintsInfoComponent } from './business-constraints-info/business-constraints-info.component';

interface DialogData {
  errors: DuplicateObjectErrorItem[];
}
interface DialogResult {}

@Component({
  selector: 'app-business-constraints-info-dialog',
  templateUrl: './business-constraints-info-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './business-constraints-info-dialog.component.scss',
  imports: [
    SuiDialogSimpleComponent,
    SuiDialogHeaderSlot,
    SuiButtonComponent,
    SuiDialogContentSlot,
    BusinessConstraintsInfoComponent,
    SuiDialogFooterSlot,
    TranslatePipe,
  ],
})
export class BusinessConstraintsInfoDialogComponent extends SuiDialogBase<
  DialogData,
  DialogResult
> {
  translateService = inject(TranslateService);

  title = this.translateService.instant('business-constraints.popup-title');
  message = this.translateService.instant(
    'business-constraints.popup-info-message',
  );

  get errors(): DuplicateObjectErrorItem[] {
    return this.dialogData.errors;
  }

  cancel() {
    this.close({ reason: DialogCloseReason.Cancel });
  }
}
